<template>
    <img  :src="getClassLogo()" :onerror="defaultImg">
</template>

<script>
    export default {
        name: 'class-icon',
        props:{
           classId: {
                required: true
            },
            logoWidth: {
                default:0,
                type: Number,
            },
            logoHeight: {
                default:0,
                type: Number,
            }
        },
        data () {
            return {
                defaultImg: `this.src="${require("../../assets/images/noclassicon.png")}"`
            }
        },

        methods: {
            getClassLogo () {
                if(!this.classId){
                    return `${require("../../assets/images/noclassicon.png")}`
                };
                return `//www.maidiyun.com/43/api/pkgclass/${this.classId}_${this.logoWidth}x${this.logoHeight}.jpg`;
            }
        }
    }
</script>
<style scoped="scoped">
    img {
        vertical-align: middle;
        max-width: 100%;
        background-color: #FFFFFF;
    }
</style>
